<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row v-if="item.is_deleted">
      <v-col>
        <span class="subtitle-1 red--text">※このデータは削除済です。</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>顧客情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <client-search
          v-if="$attrs.isCreate"
          :has-set="client_haset"
          @setClient="setClient($event)">
        </client-search>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*顧客コード"
          v-model="item.client.cd"
          :error-messages="validation_errors.client.cd"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="業種分類"
          :items=$store.getters.industryCodes
          item-text="label"
          item-value="id"
          v-model="item.client.industrycode"
          :error-messages="validation_errors.client.industrycode"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="検索用カナ"
          v-model="item.client.search_kana"
          :error-messages="validation_errors.client.search_kana"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*会社名または個人名"
          v-model="item.client.name1"
          :error-messages="validation_errors.client.name1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="部署名"
          v-model="item.client.name2"
          :error-messages="validation_errors.client.name2"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="課名"
          v-model="item.client.name3"
          :error-messages="validation_errors.client.name3"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="名前"
          v-model="item.client.name4"
          :error-messages="validation_errors.client.name4"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="敬称"
          :items="$store.getters.nameTitles"
          item-text="name"
          item-value="id"
          v-model="item.client.name_title"
          :error-messages="validation_errors.client.name_title"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*郵便番号"
          prepend-inner-icon="mdi-magnify"
          v-model="item.client.zipcode"
          @change="searchAddress"
          :error-messages="validation_errors.client.zipcode"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*都道府県"
          :items=$store.getters.prefectures
          item-text="name"
          item-value="id"
          v-model="item.client.prefecture"
          :error-messages="validation_errors.client.prefecture"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*住所1"
          v-model="item.client.address1"
          :error-messages="validation_errors.client.address1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所2"
          v-model="item.client.address2"
          :error-messages="validation_errors.client.address2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="電話番号"
          v-model="item.client.tel"
          :error-messages="validation_errors.client.tel"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="FAX"
          v-model="item.client.fax"
          :error-messages="validation_errors.client.fax"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.client.note"
          :error-messages="validation_errors.client.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>購読情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="*商品カテゴリ"
          :items="$store.getters.productCategories"
          item-text="name"
          item-value="id"
          v-model="item.productcategory_id"
          :error-messages="validation_errors.productcategory_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="*商品"
          :items="products"
          item-text="name"
          item-value="id"
          v-model="item.product_id"
          :error-messages="validation_errors.product_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="*商品明細"
          :items="productdetails"
          item-text="name"
          item-value="id"
          v-model="item.productdetail_id"
          :error-messages="validation_errors.productdetail_id"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
          :error-messages="validation_errors.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*個数"
          v-model.number="item.amount"
          :error-messages="validation_errors.amount"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="正価"
          readonly
          v-model="computed_item.list_price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*見積もり金額"
          v-model="item.price"
          :error-messages="validation_errors.price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*送料"
          v-model="item.delivery_price"
          :error-messages="validation_errors.delivery_price"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="*有効期限"
              readonly
              v-on="on"
              v-model="item.expired"
              :error-messages="validation_errors.expired"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.expired"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="!item.is_deleted">
      <v-col
        cols="12"
        md="3"
        sm="3"
      ><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
      <v-col
        cols="12"
        md="3"
        sm="3"
        v-if="!$attrs.isCreate">
        <v-btn class="red white--text" @click="download">見積書をダウンロード</v-btn>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="3"
        v-if="!$attrs.isCreate && !item.subscription && item.id">
        <v-btn class="red white--text" :to="{'name': 'CreateSubscriptionFromQuotation', 'params': {quotation_id: item.id}}">購読情報を作成する</v-btn>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="3"
        v-if="!$attrs.isCreate && item.subscription">
        <v-btn class="red white--text" :to="{'name': 'EditSubscription', 'params': {id: item.subscription}}">購読情報へ</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientSearch from '@/components/ClientSearch'
import AddressSearch from '@/plugins/AddressSearch'

export default {
  components: {
    'client-search': ClientSearch,
  },
  data() {
    return {
      title: '',
      item: {
        'client': {'prefecture': null, 'address1': ''},
      },
      validation_errors: {
        'client': {},
      },
      products: [],
      productdetails: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      client_haset: false,
    }
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "見積書登録"
    } else {
      this.title = "見積書編集"
      this.getItem();
    }
  },
  computed: {
    computed_item() {
      let list_price = null;
      let unit_list_price = null;
      if (this.item.productdetail_id) {
        unit_list_price = this.productdetails.filter(x => x.id == this.item.productdetail_id)[0].price;
      }
      if (this.item.amount) {
        list_price = unit_list_price * this.item.amount;
      }
      let sum_amount = null;
      let sum_list_price = null;
      let sum_delivery_price = null;
      if (this.item.delivery_to_others) {
        sum_amount = 0;
        this.item.subscriptiondeliveries.forEach(element => {sum_amount = sum_amount + parseInt(element.amount);});
        if (unit_list_price) {
          sum_list_price = unit_list_price * sum_amount;
        }
        sum_delivery_price = 0;
        this.item.subscriptiondeliveries.forEach(element => {sum_delivery_price = sum_delivery_price + parseInt(element.delivery_price);});
      } else {
        // SUMにはどちらにしても値を入れておく
        sum_amount = this.item.amount;
        sum_list_price = list_price;
        sum_delivery_price = this.item.delivery_price;
      }
      return {
        list_price: list_price,
        sum_amount: sum_amount,
        sum_list_price: sum_list_price,
        sum_delivery_price: sum_delivery_price,
      }
    }
  },
  watch: {
    'item.productcategory_id': async function(val) {
      await this.loadProducts(val);
    },
    'item.product_id': async function(val) {
      await this.loadProductDetails(val);
    }
  },
  methods: {
    setClient(item) {
      this.item.client = item;
      if (item.id) {
        this.client_haset = true;
      } else {
        this.client_haset = false;
      }
    },
    async searchAddress() {
      const address_data = await AddressSearch.getAddressFromZipcode(this.item.client.zipcode);
      if (address_data) {
        this.item.client.prefecture = address_data.prefcode;
        this.item.client.address1 = address_data.address;
      }
    },
    async loadProducts(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
            {
              params: {'productcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.products = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.products = []
      }
    },
    async loadProductDetails(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.productdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.productdetails = [];
      }
    },
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/${this.$route.params.id}/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
        )
        const data = response.data;
        data.productcategory_id = data.productdetail.product.productcategory.id;
        await this.loadProducts(data.productdetail.product.productcategory.id)
        data.product_id = data.productdetail.product.id;
        await this.loadProductDetails(data.productdetail.product.id)
        this.item = data;
      } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/`,
          {...this.item, ...this.computed_item},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.validation_errors = {
          'client': {},
        };
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.$router.push({'name': 'EditQuotation', 'params': {id: response.data.id}});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status >= 401 && error_status < 500) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
        if (!this.validation_errors.client) {
          this.validation_errors.client = {};
        }
      }
    },
    async update() {
      try {
        await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/${this.$route.params.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        this.validation_errors = {
          'client': {},
        };
        await this.getItem();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status >= 401 && error_status < 500) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.resopnse.data;
        if (!this.validation_errors.client) {
          this.validation_errors.client = {};
        }
      }
    },
    async download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/${this.$route.params.id}/pdf/`,
          {
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "quotation.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        
      } catch(error) {
        const error_status = error.response.status;
        if (error_status >= 401 && error_status < 500) {
          this.$store.dispatch('userLogout');
        }
        console.log(error.response.data);
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>